export default "__VITE_ASSET__C6sGVbVm__"